import { screenXsMax, Text, titleLarge, screenMdMax, titleMedium } from '@spotify-internal/encore-web';
import styled from 'styled-components';
import { DELAYS, fadeInAnimation, withAnimationContext, } from '../../Animations';
export const Heading = withAnimationContext(styled(Text).attrs({
    variant: 'titleLarge',
    className: 'heading',
}) `
    ${fadeInAnimation(DELAYS.SECOND)};
    display: block;
    @media (max-width: ${screenMdMax}) {
      ${titleMedium}

    }
    @media (max-width: ${screenXsMax}) {
      ${titleLarge}
    }
  `);
